"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _HeaderRow = _interopRequireDefault(require("./HeaderRow"));

/* eslint jsx-a11y/no-noninteractive-element-interactions: 0 */
function getHeaderRows(columns) {
  var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  rows[currentRow] = rows[currentRow] || [];
  columns.forEach(function (column) {
    if (column.rowSpan && rows.length < column.rowSpan) {
      while (rows.length < column.rowSpan) {
        rows.push([]);
      }
    }

    if (column.children) {
      getHeaderRows(column.children, currentRow + 1, rows);
    }

    if (column.colSpan !== 0) {
      rows[currentRow].push(column);
    }
  });
  return rows.filter(function (row) {
    return row.length > 0;
  });
}

var Header =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderHeaderRow", function (columns, index) {
      return _react.default.createElement(_HeaderRow.default, (0, _extends2.default)({}, _this.props, {
        key: index,
        columns: columns
      }));
    });
    return _this;
  }

  (0, _createClass2.default)(Header, [{
    key: "render",
    value: function render() {
      var columnManager = this.context.columnManager;
      var tableType = this.props.tableType;
      var columns;

      if (tableType === 'left') {
        columns = columnManager.leftColumns();
      } else if (tableType === 'right') {
        columns = columnManager.rightColumns();
      } else {
        columns = columnManager.groupedColumns();
      }

      var rows = getHeaderRows(columns);
      return _react.default.createElement("thead", null, rows.map(this.renderHeaderRow));
    }
  }]);
  return Header;
}(_react.Component);

(0, _defineProperty2.default)(Header, "contextTypes", {
  columnManager: _propTypes.default.any.isRequired
});
Header.propTypes = {
  tableType: _propTypes.default.oneOf(['left', 'main', 'right']).isRequired
};

var _default = (0, _emotionTheming.withTheme)(Header);

exports.default = _default;